<div class="bulk-export-view-container flex flex-col h-full">
  <div class="header">
    <ng-container>
      <span>Export Columns</span>
    </ng-container>
    <i class="material-icons" saAutomatedSelector="user-group__close-button" (click)="closeClicked()">close</i>
  </div>
  <div class="detail-content flex-1 overflow-y-auto">
    <div class="content-header">Columns List</div>
    <div class="flex flex-col">
      <div class="form-field-label">
        <label>Template</label>
      </div>
      <mat-form-field appearance="outline" *ngIf="!isFetchingTemplate; else fetchingTemplate">
        <mat-select (selectionChange)="onTemplateSelected($event.value)" [(value)]="selectedTemplate">
          <mat-select-trigger>
            <div class="flex items-center justify-between w-full">
              <span>{{ selectedTemplate?.templateName }}</span>
              <div class="ml-2">
                <mat-icon class="ml-1" (click)="promptEditTemplate($event)">edit</mat-icon>
                <mat-icon class="ml-1" (click)="promptDeleteTemplate($event)">delete</mat-icon>
              </div>
            </div>
          </mat-select-trigger>
          <mat-option
            *ngFor="let template of templateList.value"
            [value]="template"
            (click)="onOptionClicked(template)"
          >
            {{ template.templateName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-template #fetchingTemplate>
        <div class="flex items-center justify-center">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      </ng-template>
    </div>
    <div style="margin-bottom: 8px;">
      <mat-checkbox [checked]="true" (change)="onAllCheckboxChange($event)">
        <span *ngIf="!allChecked.value">Select All</span>
        <span *ngIf="allChecked.value">Unselect All</span>
      </mat-checkbox>
    </div>
    <div *ngFor="let col of _columns" style="margin-bottom: 8px;">
      <mat-checkbox [ngModel]="col.checked" (change)="onCheckboxChange(col, $event)">
        {{ col.name }}
      </mat-checkbox>
    </div>
  </div>

  <div class="w-full flex flex-row justify-between gap-1 mt-auto px-1 py-1 bg-white">
    <button
      class="w-full flex justify-center items-center py-1 px-2 rounded"
      style="background-color: #1F7A8C; margin-top: 14px;"
      (click)="updateColumnSelection()"
    >
      <span class="text-white uppercase justify-self-center">Apply</span>
    </button>
    <button
      class="w-full flex justify-center items-center py-1 px-2 rounded"
      style="background-color: #1F7A8C; margin-top: 14px;"
      (click)="promptSaveAsTemplate()"
    >
      <span class="text-white uppercase justify-self-center">Save as Template</span>
    </button>
  </div>
</div>
